import { useCallback } from 'react';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { AddCircleIcon, EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';
import { PatientEntitlementCreateLink } from '../create/PatientEntitlementCreateLink';

import {
   usePatientEntitlementDataConfiguration,
   usePatientEntitlementsTableColumns,
} from './PatientEntitlementsTable.hooks';

type PatientEntitlementsTableProps = {
   readonly patientId: Patient['id'];
};

export const PatientEntitlementsTable = (props: PatientEntitlementsTableProps): JSX.Element => {
   const dataConfiguration = usePatientEntitlementDataConfiguration({
      patientId: props.patientId,
   });
   const columns = usePatientEntitlementsTableColumns({
      patientId: props.patientId,
      onPatientEntitlementDocumentUpdated: dataConfiguration.refetch,
   });

   const handlePatientEntitlementsDocumentCreated = useCallback(async () => {
      return dataConfiguration.refetch();
   }, [dataConfiguration]);

   return (
      <Table
         testId={'patientEntitlements'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         placeholder={
            <EmptyStatePlaceholder
               heading={patientEntitlementsTranslationKeys.noAdditionalEntitlements}
               subheading={patientEntitlementsTranslationKeys.noAdditionalEntitlementsAssignedToPatient}
               testId={'noAdditionalEntitlements'}
            >
               <PatientEntitlementCreateLink
                  patientId={props.patientId}
                  label={patientEntitlementsTranslationKeys.addEntitlement}
                  onPatientEntitlementsDocumentCreated={handlePatientEntitlementsDocumentCreated}
               />
            </EmptyStatePlaceholder>
         }
         bottomElement={
            dataConfiguration.dataPart?.data.length ? (
               <PatientEntitlementCreateLink
                  patientId={props.patientId}
                  label={patientEntitlementsTranslationKeys.addAdditionalEntitlement}
                  icon={<AddCircleIcon />}
                  onPatientEntitlementsDocumentCreated={handlePatientEntitlementsDocumentCreated}
               />
            ) : undefined
         }
      />
   );
};
